import { defineStore } from 'pinia'
import { IdentityData } from '~concierge/types/IdentityTypes'

export const useIdentityStore = defineStore({
  id: 'identity',
  state: () => ({
    identity: null as IdentityData | null
  }),
  actions: {
    setIdentity(identityData: IdentityData) {
      this.identity = identityData
    },
    clearIdentity() {
      this.identity = null
    }
  }
})
